import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

const VerifyPhoneStrings = {
  title: () => i18n.t(i18nKeys.phoneVerify__verifyPhone__title),
  subtitle: () => i18n.t(i18nKeys.phoneVerify__verifyPhone__subtitle),
  primaryAction: () => i18n.t(i18nKeys.phoneVerify__verifyPhone__primaryAction),
  secondaryAction: () => i18n.t(i18nKeys.phoneVerify__verifyPhone__secondaryAction)
}

const UpdatePhoneStrings = {
  title: () => i18n.t(i18nKeys.phoneVerify__updatePhone__title),
  subtext1: () => i18n.t(i18nKeys.phoneVerify__updatePhone__subtext1),
  subtext2: () => i18n.t(i18nKeys.phoneVerify__updatePhone__subtext2),
  subtext3: (phoneNumberLastFour: string) => i18n.t(i18nKeys.phoneVerify__updatePhone__subtext3, { phoneNumberLastFour }),
  primaryAction: () => i18n.t(i18nKeys.phoneVerify__updatePhone__primaryAction),
  phoneFieldLabel: () => i18n.t(i18nKeys.phoneVerify__updatePhone__phoneFieldLabel),
  successNotification: () => i18n.t(i18nKeys.phoneVerify__updatePhone__successNotification),
}

export const PhoneVerifyStrings = {
  verifyPhone: VerifyPhoneStrings,
  updatePhone: UpdatePhoneStrings
}

export default PhoneVerifyStrings

